import {AbstractControl, ValidationErrors} from '@angular/forms';
import {Utils} from '@astek/utils';

export function usedDateRangeValidator(control: AbstractControl): ValidationErrors | null {
  const usedAtFromControl: AbstractControl<Date | null> | null = control.get('usedAtFrom');
  const usedAtToControl: AbstractControl<Date | null> | null = control.get('usedAtTo');
  if (Utils.isNull(usedAtFromControl) || Utils.isNull(usedAtToControl)) {
    return null;
  }
  switch (true) {
    case Utils.isNull(usedAtFromControl.value) && Utils.isNull(usedAtToControl.value):
      usedAtFromControl.setErrors(null);
      usedAtToControl.setErrors(null);
      break;
    case Utils.isNull(usedAtFromControl.value):
      usedAtFromControl.setErrors({incorrect: true});
      break;
    case Utils.isNull(usedAtToControl.value):
      usedAtToControl.setErrors({incorrect: true});
      break;
    case Utils.isNotNull(usedAtFromControl.value) && Utils.isNotNull(usedAtToControl.value) &&
    usedAtToControl.value < usedAtFromControl.value:
      usedAtToControl.setErrors({incorrect: true});
      break;
    default:
      usedAtFromControl.setErrors(null);
      usedAtToControl.setErrors(null);
  }
  return null;
}
